import { render, staticRenderFns } from "./StoreTypeBreakdownBarchart.vue?vue&type=template&id=1c6cce6f&scoped=true"
import script from "./StoreTypeBreakdownBarchart.vue?vue&type=script&lang=js"
export * from "./StoreTypeBreakdownBarchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6cce6f",
  null
  
)

export default component.exports